import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import classes from './EmptyMessage.module.scss';

const messages = defineMessages({
  emptyMessage: { id: 'components.globalSearch.emptyMessage', defaultMessage: 'There are no matches for your search.' }
});

const EmptyMessageComponent = (props) => {
  const { customMessage, customStyle } = props;
  const message = customMessage || props.intl.formatMessage(messages.emptyMessage);

  return (
    <div key="emptyMessage" className={classes.emptyMessage} style={customStyle}>
      <div>{message}</div>
    </div>
  );
};

export default injectIntl(EmptyMessageComponent);

EmptyMessageComponent.propTypes = {
  customMessage: PT.string,
  customStyle: PT.object,
  intl: PT.object
};
